import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clear() {
    try {
      localStorage.removeItem("seeniq_map_currentLat")
      localStorage.removeItem("seeniq_map_currentLng")
      localStorage.removeItem("seeniq_map_zoom")
    } catch (error) {
      console.warn("Failed to clear map state from localStorage", error)
    }
  }
}


